import angular from 'angular';

function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('eventRealtime', {
    url: '/event-realtime',
    templateProvider: () =>
      import(/* webpackChunkName: "event-realtime" */ './event-realtime.pug').then(
        ({ default: tpl }) => tpl,
      ),
    controller: 'eventRealtimeCtrl as vm',
    requiredPermission: 'eventRealtime',
    resolve: {
      loadCtrl: $ocLazyLoad =>
        Promise.all([
          import(/* webpackChunkName: "event-realtime" */ './event-realtime.controller'),
          import('../../extensions/init/ag-grid'),
          import('../../extensions/directives/select2'),
          import('../../extensions/directives/date-range-picker'),
        ]).then(([module]) => {
          $ocLazyLoad.load({ name: module.name });
          return module.controller;
        }),
    },
  });
}

export default angular.module('app.eventRealtime.routing', []).config(routes);
